import { Component, Input, NgZone } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { RedirectHelper } from '@app/app/page-modules/resource/store/editor/content/helpers/redirect.helper';
import { NestedPathHelper } from '@app/app/shared/helpers/nested-path.helper';
import { CardsLayoutType, PlaylistCardShort } from '@app/app/shared/models';

@Component({
  selector: 'ptl-collection-cards-view',
  templateUrl: './collection-cards-view.component.html',
  styleUrls: ['./collection-cards-view.component.scss'],
})
export class CollectionCardsViewComponent {
  @Input() cards: PlaylistCardShort[] = [];
  @Input() currentLayoutView: CardsLayoutType = 'CardView';

  constructor(
    private router: Router,
    private ngZone: NgZone,
    private activatedRoute: ActivatedRoute,
  ) {}

  onCardClick(card: PlaylistCardShort): void {
    if (card.lmsCourseUrl) {
      window.open(card.lmsCourseUrl, '_blank', 'noopener,noreferrer');
      return;
    }

    const cardUri = card.uri || card.formattedUri;
    if (!cardUri) {
      return;
    }

    // Cards always use nested path (cards are children of a course/program)
    if (card.type === 'CARD') {
      const currentUrl = this.router.url.split('?')[0];
      const newCardPath = NestedPathHelper.addEntityToPath(currentUrl, 'card', cardUri, 'content');
      RedirectHelper.redirectByUrl(this.ngZone, this.router, this.activatedRoute, newCardPath);
      return;
    }

    // Courses navigate to flat /courses/:uri/content
    const isProgram = card.v3CardType === 'PROGRAM' || card.collectionType === 'PROGRAM';
    if (isProgram) {
      RedirectHelper.redirectByUrl(this.ngZone, this.router, this.activatedRoute, `/programs/${cardUri}/content`);
    } else {
      RedirectHelper.redirectByUrl(this.ngZone, this.router, this.activatedRoute, `/courses/${cardUri}/content`);
    }
  }
}
